// Default value for the sponsor_inquiries store. Empty because nothing is pre-seeded —
// inquiries only exist once a prospective sponsor fills the deck form.
export const SPONSOR_INQUIRIES = [];
